import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateTnplSettings = {
  name: "updateTnplSettings" as const,
  input: z.object({
    teamId: zExt.objectId(),
    enabled: z.boolean(),
    useMinutesForTrialPeriod: z.boolean().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
